import {FormGroup, Icon, Label} from '@blueprintjs/core';
import {Tooltip2} from '@blueprintjs/popover2';
import React, {useState} from 'react';
import styled from 'styled-components';
import {jurisdictionTypeOptions, sizeOptions} from '../modules/options';
import FilterSelect from './FilterSelect';
import SelectBox from './SelectBox';

export default function SubscriptionDetailsForm({account, onChange}) {
  const [formData, setFormData] = useState(account);

  const handleChange = (label, value) => {
    setFormData(data => ({...data, [label]: value}));
    onChange({[label]: value});
  };

  return (
    <form style={{alignItems: 'stretch', gap: '15px'}}>
      <div>
        <Label style={{marginBottom: '5px'}}>Plan Type:</Label>
        <FilterSelect
          id="jurisdictionType"
          items={jurisdictionTypeOptions}
          onSelect={item => handleChange('jurisdictionType', item.id)}
          activeItem={{id: formData.jurisdictionType || ''}}
          popoverProps={{minimal: true}}
        >
          <SelectBox>
            {formData.jurisdictionType ?? 'Select a Plan Type'}
          </SelectBox>
        </FilterSelect>
      </div>
      <FormInput>
        <FormGroup
          label={'Size:'}
          labelInfo={
            <Tooltip2
              content={
                <TooltipContent>
                  <p>
                    Business account subscription plans are based on employer
                    size (number of Canadian employees).
                    <ul>
                      <li>
                        Small accounts are for employers with 1-249 employees
                      </li>
                      <li>
                        Medium accounts are for employers with 250-2499
                        employees
                      </li>
                      <li>
                        Large accounts are for employers with 2500-9999
                        employees
                      </li>
                      <li>
                        Enterprise accounts are for employers with 10,000+
                        employees
                      </li>
                    </ul>
                    You agree to provide accurate employee count information
                    when purchasing your subscription, and to advise Compliance
                    Works prior to your renewal if changes in your employee
                    account change the applicable subscription plan.
                  </p>
                </TooltipContent>
              }
              position="bottom"
              intent="primary"
            >
              <Icon icon="info-sign" size={12} />
            </Tooltip2>
          }
        >
          <FilterSelect
            id="size"
            items={sizeOptions.filter(({id}) => id !== 'Service Provider')}
            onSelect={item => handleChange('size', item.id)}
            activeItem={{id: formData.size || ''}}
            popoverProps={{minimal: true}}
          >
            <SelectBox>{formData.size ?? 'Select a Size'}</SelectBox>
          </FilterSelect>
        </FormGroup>
      </FormInput>
    </form>
  );
}

const FormInput = styled.div`
  .bp3-inline {
    justify-content: flex-start;
  }

  .bp3-label {
    min-width: 275px;

    .bp3-text-muted .bp3-popover2-target {
      display: inline-block;
      margin-top: 0px;

      svg {
        margin-bottom: 2px;
      }
    }
  }
`;

const TooltipContent = styled.div`
  width: 300px;

  li {
    margin-bottom: 4px;
  }
`;
